import { render, staticRenderFns } from "./FileMenu.vue?vue&type=template&id=44d91bd9&"
import script from "./FileMenu.vue?vue&type=script&lang=js&"
export * from "./FileMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports